import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 55 55"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M38.73 8.25H16.27a8.02 8.02 0 0 0-8.02 8.02v22.46c0 4.428 3.592 8.02 8.02 8.02h22.46a8.02 8.02 0 0 0 8.02-8.02V16.27a8.02 8.02 0 0 0-8.02-8.02M21.082 38.73h-4.812V21.082h4.812zm-2.406-19.68c-1.55 0-2.807-1.268-2.807-2.83s1.258-2.83 2.807-2.83c1.55 0 2.807 1.267 2.807 2.83 0 1.562-1.256 2.83-2.807 2.83m21.656 19.68h-4.812v-8.99c0-5.403-6.417-4.994-6.417 0v8.99h-4.812V21.082h4.812v2.832c2.24-4.149 11.23-4.455 11.23 3.972z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "linkedin"}) } }